// src/pages/profile/activity/liked-posts/components/VirtualList.jsx

import PropTypes from 'prop-types';

import PostVirtualList from '@/pages/profile/board/components/PostVirtualList';

/**
 * Liked Posts → reuse the exact same PostVirtualList
 * that the main feed and ProfileBoard use.
 *
 * @param {{ data: Array, totalDocs: number }} items
 * @param {() => void} onLoadMore
 */
export default function VirtualList({ items, onLoadMore }) {
  return <PostVirtualList items={items} onLoadMore={onLoadMore} />;
}

VirtualList.propTypes = {
  items: PropTypes.shape({
    data: PropTypes.array.isRequired,
    totalDocs: PropTypes.number.isRequired
  }).isRequired,
  onLoadMore: PropTypes.func.isRequired
};
